import ProfileView from '@/components/profile/profile-view'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/dashboard_/profile')({
  component: RouteComponent,
  beforeLoad: ({ context: { user } }) => {
    if (user?.isAdmin) throw redirect({ to: '/sign-out' })
    return { breadcrumb: 'Profile', user }
  },
  loader: async ({ context: { orpc, queryClient, user } }) => {
    await queryClient.ensureQueryData(
      orpc.backoffice.villages.getById.queryOptions({
        input: { villageId: user?.village?.id ?? '' }
      })
    )
  }
})

function RouteComponent() {
  const { orpc, user } = Route.useRouteContext()

  return <ProfileView user={user} orpc={orpc} />
}
